import { forwardRef } from "react";
function SvgRawErrorIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#1D1D1D"
        stroke="#1D1D1D"
        strokeWidth={2}
        d="m15.44 3.684 4.874 4.868.002 6.889-4.868 4.873-6.889.002-4.872-4.868-.003-6.889 4.868-4.872 6.889-.003Z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 17v.01M12 7v6"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawErrorIcon);
export default ForwardRef;
